import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from '../login/services/auth-service.service';
import { finalize } from 'rxjs';
import { ChangePassword } from 'src/app/entities/ChangePassword';

@Component({
  selector: 'app-cambiar-contrasena',
  templateUrl: './cambiar-contrasena.component.html',
  styleUrls: ['./cambiar-contrasena.component.scss']
})
export class CambiarContrasenaComponent {
  minCaracteres = false;
  maxCaracteres = false;
  hasNumber = false;
  hasMinus = false;
  hasMayus = false;
  espCaracter = false;
  public hidePass: boolean = true;
  public hideNewPass: boolean = true;
  public hideConfirm: boolean = true;
  public usuarioForm: FormGroup;

  constructor(private fb: FormBuilder, private toastr: ToastrService, private authService: AuthServiceService) { }

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    const pattern = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{6,}$/;
    this.usuarioForm = this.fb.group({
      PasswordActual: ['', [
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(16),
        Validators.pattern(pattern)
      ]],
	  passwordGroup: this.fb.group({
		PasswordNuevo: [
		  "",
		  Validators.compose([
			Validators.required,
			Validators.minLength(6),
			Validators.maxLength(16),
			Validators.pattern(
			  "^(?=.*\\d)(?=.*[A-Z])(?=.*[a-z])(?=.*\\W).{6,16}$"
			),
		  ]),
		], 
		ConfirmarPassword: [
            "",
            Validators.compose([
              Validators.required,
              Validators.minLength(6),
              Validators.maxLength(16),
              Validators.pattern(
                "^(?=.*\\d)(?=.*[A-Z])(?=.*[a-z])(?=.*\\W).{6,16}$"
              ),
            ]),
          ],
	  },{validator: passwordMatcher}),
	});

  }

  cambiarContrasena() {
	const control = this.usuarioForm.get("passwordGroup"); 
    if (control.get('PasswordNuevo')?.value === control.get('ConfirmarPassword')?.value) {
		const data: ChangePassword = {
			passwordActual: this.usuarioForm.get('PasswordActual').value,
			passwordNuevo: control.get('PasswordNuevo').value,
			confirmarPassword: control.get('ConfirmarPassword').value,
		}
      this.authService.changePassword(data).pipe(
        finalize(() => {
          this.toastr.success('Actualización correcta');
        })
      ).subscribe();
    } else {
      this.toastr.error('Las contraseñas no coinciden');
    }
  }

  onPasswordInput(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.minCaracteres = value.length >= 6;
    this.maxCaracteres = value.length <= 16;
    this.hasNumber = /\d/.test(value);
    this.hasMinus = /[a-z]/.test(value);
    this.hasMayus = /[A-Z]/.test(value);
    this.espCaracter = /[^\w\d]/.test(value);
  }

  togglePassword(key: string) {
    if (key === "password") {
      this.hidePass = !this.hidePass;
    } else if (key === "newPass") {
      this.hideNewPass = !this.hideNewPass;
    } else {
      this.hideConfirm = !this.hideConfirm;
    }
  }
}

function passwordMatcher(c: AbstractControl): { [key: string]: boolean } | null {
  const passwordControl = c.get('PasswordNuevo');
  const confirmPasswordControl = c.get('ConfirmarPassword');

  if (passwordControl.pristine || confirmPasswordControl.pristine) {
    confirmPasswordControl.setErrors(null);
    return null;
  }

  if (passwordControl.value === confirmPasswordControl.value) {
    confirmPasswordControl.setErrors(null);
    return null;
  }

  confirmPasswordControl.setErrors({ 'match': true });

  return { 'match': true };
}
